module.exports = __webpack_public_path__ + "static/img/qiangcha2.7dc7c93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/qiangcha2.png
// module id = M8pz
// module chunks = 24